import { z } from 'zod'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

export function useDisplayNameValidation() {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const schema = z
    .string()
    .min(3, t('Display name must be at least 3 characters.'))
    .max(100, t('Display name must be less than 100 characters.'))
    .regex(/^[a-zA-Z0-9 _.\-<>+!¡$€£¥]+$/, t('Invalid characters in display name.'))

  return (displayName: string) => {
    const result = schema.safeParse(displayName)
    return result.success ? null : result.error.errors[0]?.message
  }
}
